<template>
  <div class="post-side">
    <template v-if="side.cards?.length">
      <h2 class="title-strat">{{ pageTitle }}</h2>
      <ul
        v-if="side.subCategoriesFilters"
        class="filters"
      >
        <li
          :class="{ current: filterSubCategory.slug == 'all' }"
          @click="changeFilterTo({ name: 'all', slug: 'all' })"
        >
          Toutes
        </li>
        <li
          v-for="subCategory in subCategories"
          :key="subCategory.slug"
          :class="{ current: filterSubCategory == subCategory }"
          @click="changeFilterTo(subCategory)"
        >
          {{ capitalize(subCategory.name) }}
        </li>
      </ul>
      <div class="slider">
        <MiniCardSlider :cards="side.cards" />
      </div>
      <template v-if="side.PSActualities?.length">
        <h2 class="title-strat">Actualité PlayStation</h2>

        <div class="slider">
          <MiniCardSlider :cards="side.PSActualities" />
        </div>
      </template>
    </template>
    <h2 class="title-strat">Tout l'univers {{ side.title }}</h2>
    <ul class="link-list">
      <li
        v-for="navItem in side.nav"
        :key="navItem.slug"
      >
        <NuxtLink
          :to="`${side.route}${renameWapersCornerUrl(navItem.slug) ? '/' : ''}${renameWapersCornerUrl(navItem.slug)}`"
        >
          {{ renameWapersCornerCategory(navItem.name) }}
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { Category, SideContent } from '~/types'

const props = defineProps<{
  side: SideContent
}>()

const pageTitle = computed(() => {
  return props.side.type === 'challenge'
    ? 'les autres challenges du mois'
    : `les autres ${props.side.navName} sur ${props.side.title}`
})

const subCategories = computed(() => {
  return props.side.subCategoriesFilters ? props.side.subCategories : []
})

const filterSubCategory = ref<Category>({ name: 'all', slug: 'all' })

const tricksStore = useTricksStore()
const waperCornersStore = useWaperCornersStore()

const changeFilterTo = async (subCategory: Category) => {
  if (!props.side?.type) return

  filterSubCategory.value = subCategory

  if (props.side.type.toLowerCase() === 'astuces') {
    if (filterSubCategory.value.slug === 'all') {
      return tricksStore.fetchOtherTricks()
    }
    return tricksStore.fetchOtherTricks(filterSubCategory.value.slug)
  } else if (props.side.type.toLowerCase() === 'le coin des wapers') {
    if (filterSubCategory.value.slug === 'all') {
      return waperCornersStore.fetchOtherWaperCorners()
    }

    return waperCornersStore.fetchOtherWaperCorners(
      filterSubCategory.value.slug,
    )
  }
}
</script>

<style lang="scss" scoped>
.post-side {
  padding-bottom: 4rem;
  background: $sideGrey;

  .title-strat {
    padding-top: 8rem;
    padding-right: 8rem;
    padding-left: 8rem;
  }

  .slider {
    margin-top: 4.7rem;
    padding-right: 8rem;
    padding-left: 8rem;
  }

  .filters {
    display: flex;
    margin-top: 4.7rem;
    padding-left: 8rem;
    overflow-x: auto;

    li {
      flex-shrink: 0;
      margin-right: 2rem;
      font-size: 1rem;
      font-weight: 500;
      line-height: 1.3rem;
      text-transform: uppercase;

      &.current {
        color: $blue;
      }

      &:last-child {
        padding-right: 2rem;
      }
    }
  }

  .link-list {
    margin-top: 2.5rem;
    padding-right: 8rem;

    li {
      border-bottom: 1px solid rgba($dark, 0.2);

      &:last-child {
        border-bottom: none;
      }

      a {
        display: block;
        height: 6.4rem;
        padding-left: 8rem;
        color: $dark;
        line-height: 6.4rem;
        text-decoration: none;
      }
    }
  }
}

@media screen and (max-width: 700px) {
  .post-side {
    padding-bottom: 4rem;
    background: $sideGrey;

    .title-strat {
      padding-top: 6rem;
      padding-right: 2.5rem;
      padding-left: 2.5rem;
    }

    .slider {
      margin-top: 4.7rem;
      padding-right: 0;
      padding-left: 0;
    }

    .filters {
      display: flex;
      margin-top: 4.7rem;
      padding-left: 2.5rem;

      li {
        margin-right: 2rem;
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.3rem;
        text-transform: uppercase;

        &.current {
          color: $blue;
        }
      }
    }

    .link-list {
      margin-top: 2.5rem;
      padding-right: 2.5rem;
      padding-left: 2.5rem;

      li {
        border-bottom: 1px solid rgba($dark, 0.2);

        &:last-child {
          border-bottom: none;
        }

        a {
          display: block;
          height: 6.4rem;
          padding-left: 0;
          color: $dark;
          line-height: 6.4rem;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
